import useAppStore from "../stores/appStore";

import { getTraceId } from "./traceId";

export const setAxiosTokenInterceptor = (axiosInstances) => {
  clearAllInterceptors(axiosInstances);
  axiosInstances.forEach((axiosInstance) => {
    axiosInstance.interceptors.request.use((requestConfig) => {
      const { selectedAssistant, selectedAccountId, accessToken } = useAppStore.getState();
      requestConfig.headers = {
        ...requestConfig.headers,
        "account-id": selectedAccountId,
        "room-id": selectedAssistant?.assistantId,
        "trace-id": getTraceId(),
        "Authorization": `Bearer ${accessToken}`
      };
      return requestConfig;
    });
  });
};

export const clearAllInterceptors = (axiosInstances) => {
  axiosInstances.forEach((instance) => {
    const requestInterceptors = instance.interceptors.request;
    if (requestInterceptors.handlers) {
      requestInterceptors.handlers.forEach((handler, id) => {
        if (handler !== null) {
          requestInterceptors.eject(id);
        }
      });
    }
  });
};
